 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		11: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"edf3535aced653b0e178639fa7f04ee143795c54","2":"249764000ce4a907875aa9f86f454af2cccef3b9","3":"48fd66a7b8563289ea94669bc022bb0d150ec79b","4":"7ba1e46e1cb5d2ed68dabe5ad1d72bd99ca4e73b","5":"8df789f331b9eb062f63d294888cb12797ef70fb","6":"c05b8182","7":"component---src-pages-layout-js","8":"f68b6560540997019da160705c016bf18f9f73c7","9":"9792b413b5a274ce46bf46d519555576faa75f82","10":"component---src-pages-integration-builder-sections-code-tsx","19":"3dcc3d58","32":"component---src-pages-404-js","33":"component---src-pages-banner-js","34":"component---src-pages-classic-home-js","35":"component---src-pages-docs-template-js","36":"component---src-pages-home-js","37":"component---src-pages-index-js","38":"component---src-pages-integration-builder-index-tsx","39":"component---src-pages-integration-builder-sections-build-tsx","40":"component---src-pages-integration-builder-sections-card-generator-tsx","41":"component---src-pages-integration-builder-sections-configure-tsx","42":"component---src-pages-integration-builder-sections-demo-tsx","43":"component---src-pages-integration-builder-sections-help-modal-tsx","44":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","45":"component---src-pages-integration-builder-sections-preview-tsx","46":"component---src-pages-integration-builder-sections-take-live-tsx","47":"component---src-pages-internal-js","48":"component---src-pages-signup-js","49":"component---src-pages-signupauto-js","50":"component---src-pages-support-js","51":"component---src-pages-thankyou-js","52":"component---src-pages-unsubscribe-js","53":"component---src-templates-template-layout-js","57":"d7eeaac4"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"4385a51a15dc099f07de","2":"6fd8b4f3aac03b6ee4e7","3":"f969cecc5abd4319b0f2","4":"ba13ab482b0455806a8b","5":"836ce34769901b45d1cb","6":"6075be5a044658d7fa4b","7":"d9f82fd7304fa3d55a1d","8":"edafdc43fa8898d7380e","9":"4ed195dffc74504d1623","10":"9cca7ee4c1599d611dcb","19":"8a2f04709edfefc564bc","32":"0a6bb3d67a8937e50fa3","33":"eee0c3fe642e7a2c9bfe","34":"a757ee4a40b721726f5c","35":"47e2822971000a5ea095","36":"003d64912686c898e68e","37":"75c099eff096f3b4c472","38":"bc2458c7b414cb465286","39":"9feec494f891126c5022","40":"a03b8faa51009bf74296","41":"79bbef776a89ed97a02f","42":"2f54bc10e60371fde972","43":"ab2270ed6cab7036eda5","44":"44e2bcaea09ec51b751d","45":"cc4fd24ab89287bd14e6","46":"481d3594e4935b16af6d","47":"4b718479c980683ce150","48":"714a096fa383072a5fa0","49":"62aa7fb9fc76f08a9b01","50":"1df47ea5395db978cec1","51":"0dfaff5ecfe7a220848a","52":"3608fed6836d0dcbdffe","53":"0fd43f5fe8a15e2ca4b7","57":"4dca5e52384c2b78ba7d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"edf3535aced653b0e178639fa7f04ee143795c54","2":"249764000ce4a907875aa9f86f454af2cccef3b9","3":"48fd66a7b8563289ea94669bc022bb0d150ec79b","4":"7ba1e46e1cb5d2ed68dabe5ad1d72bd99ca4e73b","5":"8df789f331b9eb062f63d294888cb12797ef70fb","6":"c05b8182","7":"component---src-pages-layout-js","8":"f68b6560540997019da160705c016bf18f9f73c7","9":"9792b413b5a274ce46bf46d519555576faa75f82","10":"component---src-pages-integration-builder-sections-code-tsx","19":"3dcc3d58","32":"component---src-pages-404-js","33":"component---src-pages-banner-js","34":"component---src-pages-classic-home-js","35":"component---src-pages-docs-template-js","36":"component---src-pages-home-js","37":"component---src-pages-index-js","38":"component---src-pages-integration-builder-index-tsx","39":"component---src-pages-integration-builder-sections-build-tsx","40":"component---src-pages-integration-builder-sections-card-generator-tsx","41":"component---src-pages-integration-builder-sections-configure-tsx","42":"component---src-pages-integration-builder-sections-demo-tsx","43":"component---src-pages-integration-builder-sections-help-modal-tsx","44":"component---src-pages-integration-builder-sections-know-before-you-code-tsx","45":"component---src-pages-integration-builder-sections-preview-tsx","46":"component---src-pages-integration-builder-sections-take-live-tsx","47":"component---src-pages-internal-js","48":"component---src-pages-signup-js","49":"component---src-pages-signupauto-js","50":"component---src-pages-support-js","51":"component---src-pages-thankyou-js","52":"component---src-pages-unsubscribe-js","53":"component---src-templates-template-layout-js","57":"d7eeaac4"}[chunkId]||chunkId) + "." + {"0":"9793d18c94f2d24c7f38","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://www.paypalobjects.com/ppdevdocs/v2noapi/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
